import { render, staticRenderFns } from "./tagEditor.vue?vue&type=template&id=3b3b41ff&scoped=true"
import script from "./tagEditor.vue?vue&type=script&lang=js"
export * from "./tagEditor.vue?vue&type=script&lang=js"
import style0 from "./tagEditor.vue?vue&type=style&index=0&id=3b3b41ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b41ff",
  null
  
)

export default component.exports